import { useState } from 'react'
import { MdClose } from 'react-icons/md'
import ConfirmDeleteOpportunity from './ConfirmDeleteOpportunity'

export default function ButtonDeleteOpportunity({ countryId, opportunityId }) {
  const [isOpen, setIsOpen] = useState(false)

  function handleOnOpenModel() {
    setIsOpen(true)
  }

  function handleOnCloseModel() {
    setIsOpen(false)
  }

  return (
    <>
      <button
        onClick={handleOnOpenModel}
        className="flex border-2 border-danger-500 bg-danger-300 p-1 text-white hover:bg-danger-500"
      >
        <MdClose size={16} />
      </button>
      <ConfirmDeleteOpportunity
        isOpen={isOpen}
        onClose={handleOnCloseModel}
        opportunityId={opportunityId}
        countryId={countryId}
      />
    </>
  )
}
